import styled from "@emotion/styled";
import Stack from "@mui/material/Stack/Stack";
import { ORGANIZATION_LAYOUT_WIDTH } from "@/features/organization/constants/section";


export const OrganizationContainer = styled(Stack)`
  width: 100%;
  max-width: ${ORGANIZATION_LAYOUT_WIDTH}px;
  margin: 0 auto;
`;
